import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

//Controllers

import { headerSearch, tabs, unoTheme } from '../../../../../assets/styles/unoTheme';


import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, withStyles } from "@material-ui/core";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { isEmpty } from 'lodash';
import moment from 'moment';
import allActions from '../../../../../actions';
import { ComDinheiroAPI } from '../../../../../API/comdinheiro-api';
import { FundAPI } from '../../../../../API/fund';
import { formatMyFundsToShow } from '../../../../../controllers/FundController';
import DefaultScrollWithHeaderContent from '../../../../utils/DefaultScrollWithHeaderContent';
import MyTable from '../../../../utils/MyTable';
import { applyMaskAmount, applyMaskAmountFreeDecimals, getDayMonthYearByDate, getFirstBeforeBusinessDay, getFirstDayMonth, getLastDayInMonthByMonthAndYear, getMonthName, getNovember, getYearsWithNovembers, portfolioClosedToDate, sortObjsByPeriod } from '../../../../utils/utils';


import { ClientAPI } from '../../../../../API/client';
import { LossProvisionAPI } from '../../../../../API/loss_provision';
import UnoButton from '../../../../utils/UnoButton';

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #000000"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        fontSize: '15px',
        backgroundColor: theme.palette.common.white,
        border: "1px solid #000000",
        color: "#000000"
    }
}))(Tooltip);

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    dirName: {
        color: 'black',
        cursor: 'pointer',
        '&:hover': {
            color: 'blue'
        }
    },
    file: {
        cursor: 'pointer',
        '&:hover': {
            color: 'blue',
            '& svg': {
                color: 'blue'
            }
        }

    },
    tabs: tabs,

    demonstrativeContainer: {
        overflowY: 'scroll',
        width: '100%',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',

        '& .demonstrativeFund': {

            marginBottom: '32px',

            '& .fundName': {
                color: unoTheme.defaultTextColor,
                paddingBottom: '16px',
                textAlign: 'left',
                fontWeight: 'bold',
                fontSize: '18px',

            },

            '& .demonstrativeTopInfos': {
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: '16px',

                '& .demonstrativeTopInfosLeft': {
                    paddingRight: '16px',
                },
                '& .demonstrativeTopInfosRight': {
                    borderLeft: 'solid 1px ' + unoTheme.mainColor,
                    paddingLeft: '16px',
                    paddingRight: '16px',
                }
            }
        }
    },
    tableBlade: {

        tableLayout: 'fixed',


        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                fontSize: '12px',
                padding: '4px 4px',
                fontWeight: "bold",
                color: '#1C2228',
                wordWrap: 'break-word',
            },

            '& .MuiTableCell-root:first-child': {
                paddingLeft: '16px',
                borderRight: 'solid 1.5px #E4E7EB'
            },
            '& > *': {
                borderBottom: 'unset',
            },
        },

        '& .MuiTableBody-root': {

            '& .MuiTableRow-root': {
                borderRadius: '10px',
                '&:nth-of-type(odd)': {
                    backgroundColor: unoTheme.secondaryTuplaTable,
                    //backgroundColor: 'red',
                },

                '&:nth-of-type(even)': {
                    backgroundColor: unoTheme.mainColor,
                    color: 'white',

                    '& .MuiTableCell-root': {
                        color: 'white',
                    },
                    //backgroundColor: 'red',
                },

                '& > *': {
                    borderBottom: 'unset',
                },
            },

            '& .MuiTableCell-root': {
                fontSize: '12px',
                padding: '12px 4px',
                color: '#768191',
            },

            '& .MuiTableCell-root:first-child': {
                borderRight: 'solid 1.5px #E4E7EB',
                paddingLeft: '16px',
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
            },

            '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
            },
        },


    },

    gridPaperTable: {
        borderRadius: '10px',
    },

    ellipsis: {
        whiteSpace: "nowrap", /* Impede a quebra de linha */
        overflow: "hidden", /* Garante que o texto extra seja ocultado */
        textOverflow: "ellipsis",
    },

    totalLinePL: {
        '& .MuiTableCell-root': {
            color: 'white',
            borderBottom: 'unset',
            background: unoTheme.mainColor,
        },
    },


    totalWithNegativesLinePL: {
        '& .MuiTableCell-root': {
            color: 'black',
            borderBottom: 'unset',
            background: unoTheme.mainGrayColor,
        },
    },

    theConsumeLine: {
        '& .MuiTableCell-root': {
            color: 'black',
            borderBottom: 'unset',
            background: unoTheme.auxYellowTable,
        },
    },

    flexCenterDiv: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    ramification1: {
        display: 'flex',
        height: '100% !important',
        width: '100% !important',
        alignItems: 'center',

        '& .rLeft': {
            height: '100%',
            width: '50%',
            marginLeft: '7px',
            '& .lTop': {
                height: '50%',
                width: '100%',
                borderRight: 'solid 1px #dddee0',
            },

            '& .lBottom': {
                height: '50%',
                width: '100%',
                borderRight: 'solid 1px #dddee0',
            },
        },

        '& .rRight': {
            height: '100%',
            width: '50%',
            '& .tTop': {
                height: '50%',
                width: '100%',
                borderBottom: `solid 1px #dddee0`,
            },

            '& .tBottom': {
                height: '50%',
                width: '100%',
            },
        },

        '& .littleBall': {
            height: '7px',
            width: '8px',
            borderRadius: '50%',
            background: unoTheme.mainColor,
            marginTop: '-1.5px',
        }

    },
    noPaddingCell: {
        padding: '0px !important',
        height: '1px',
    },

    hiddenIcon: {
        visibility: 'hidden'
    },
    arrowTableIcon: {
        background: unoTheme.mainColor,
        color: 'white',
        borderRadius: '4px',
        height: '22px',
        width: '22px',

        '&:hover': {
            color: 'white',
            background: unoTheme.hoverMainButtonColor
        }
    },


});


export default function LossProvisionTab(props) {

    const { selectedYearLossProvision,
        setOptionsYearsLossProvision, setLossProvisionResult, setFooterLoss } = props;

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const [settledFundsIds, setSettledFundsIds] = useState([]);
    const [fundsFormatteds, setFundsFormatteds] = useState([]);
    const [formattedConsumes, setFormattedConsumes] = useState([]);

    const [theNovember, setTheNovember] = useState();

    const [enableGenerateLossProvisionYear, setEnableGenerateLossProvisionYear] = useState(false);

    const [totalLoss, setTotalLoss] = useState();

    const [innerLoad, setInnerLoad] = useState({
        emptyMessage: "",
        loadMessage: "Carregando provisão de perdas...", size: "small"
    });

    async function loadFundsYear(client, optionYear) {

        setInnerLoad({
            emptyMessage: "",
            loadMessage: "Gerando provisão " + optionYear + "...", size: "small"
        })
        const lastNovember = getNovember(optionYear);
        console.log("lastNovember ", lastNovember);
        const { month, year } = getDayMonthYearByDate(lastNovember);

        setTheNovember(moment.utc(lastNovember).format("MM/YYYY"));

        const currentPeriod = month + '/' + year;
        const startDate = moment.utc(client.portfolio_init).format('DD/MM/YYYY');
        const endDate = getLastDayInMonthByMonthAndYear(month, year);

        const responseRents = await ClientAPI.getRentsByPeriod(client.id, startDate, endDate, "", 0);

        if (responseRents.integralFundsBalancesMap) {

            if (Object.keys(responseRents.integralFundsBalancesMap).length) {

                const fundsIds = Object.keys(responseRents.integralFundsBalancesMap);

                const responseSettledFundsIds = await FundAPI.getSettledFundsIdsByFundsIdsAndReferenceDate(fundsIds, getFirstDayMonth(month, year));

                let setteldsIds = [];
                if (responseSettledFundsIds?.success) {

                    setteldsIds = responseSettledFundsIds.body.rows.map(el => el.id + "");
                    setSettledFundsIds(setteldsIds);
                }

                const responseFundsInfos = await FundAPI.getFundsInfosByFundIds(fundsIds);

                if (responseFundsInfos.success) {
                    //transformar em map
                    const mapFundsInfos = {};
                    const justCnpjs = [];
                    responseFundsInfos.body.rows.forEach(el => {
                        mapFundsInfos[el.id] = el;
                        justCnpjs.push(el.cnpj);
                    })


                    const responseVaRs = await ComDinheiroAPI.getVaRs(getFirstBeforeBusinessDay(endDate), justCnpjs);

                    if (isEmpty(responseRents.integralFundsBalancesMap)) {
                        setInnerLoad({
                            emptyMessage: "Não existem fundos",
                        });
                    }

                    const preFormatted = formatMyFundsToShow(responseRents.integralFundsBalancesMap, currentPeriod, mapFundsInfos);

                    if (responseVaRs?.success) {

                        console.log("responseVaRs: ", responseVaRs.body);
                        const { body } = responseVaRs;
                        let loss = 0;
                        preFormatted.forEach(el => {

                            if (body[el.cnpj] != null) {
                                const factor = body[el.cnpj].var * Math.sqrt(252);
                                el.factor = factor;
                                if (el.balance_now != null) {
                                    el.provision = el.balance_now * factor;
                                    loss += el.provision;
                                }
                                el.var = factor * 100;
                                el.varMode = body[el.cnpj].varMode;
                            }
                        })

                    }

                    const responseSaveLossProvisionYear = await LossProvisionAPI.saveLossProvisionYear(client.id,
                        selectedYearLossProvision,
                        JSON.stringify(preFormatted.filter(el =>
                            !setteldsIds.includes(el.fundId)
                            && el.balance_now > 0
                            && el.var > 0
                        )));


                    loadYearLossProvision(client, selectedYearLossProvision);

                } else {
                    setInnerLoad(null);

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        message: "Falha ao trazer fundos do cliente",
                        type: 'error',
                    }))
                }
            } else {
                setInnerLoad({ emptyMessage: "Não existem fundos" })

            }



        } else {

            setInnerLoad(null);

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao trazer fundos do cliente",
                type: 'error',
            }))
        }
    }


    const loadYearLossProvision = async (client, year) => {

        const clientId = client.id;



        const responseYearLoss = await LossProvisionAPI.getYearLossProvision(clientId, year);
        if (responseYearLoss.success) {

            if (responseYearLoss.body?.rows?.length == 0) {
                setEnableGenerateLossProvisionYear(true);
                setInnerLoad(null);
            } else {

                setEnableGenerateLossProvisionYear(false);
                const theLossProvision = responseYearLoss.body.rows[0];
                const formattedFunds = JSON.parse(theLossProvision.loss_provision);
                setTotalLoss(formattedFunds.reduce((sum, item) => sum + (item.provision ? item.provision : 0), 0));
                const result = JSON.parse(theLossProvision.loss_provision);
                console.log("result: ", result);

                const mapFundNameByFundId = {};
                const mapFundCnpjByFundId = {};
                result.forEach(fund => {
                    if (!mapFundNameByFundId[fund.fundId]) {
                        mapFundNameByFundId[fund.fundId] = fund.fund_name;
                    }
                    if (!mapFundCnpjByFundId[fund.fundId]) {
                        mapFundCnpjByFundId[fund.fundId] = fund.cnpj;
                    }
                });

                setFundsFormatteds(result);

                const endDate = portfolioClosedToDate(client.portfolio_closed);
                const startDate = new Date(year, 11, 1);

                const { resultFunds } = await ClientAPI.getRentsByPeriod(clientId,
                    moment.utc(startDate).format('DD/MM/YYYY'),
                    moment.utc(endDate).format('DD/MM/YYYY'), null, null)

                console.log("resultFunds: ", resultFunds);

                const formattedConsumesPeriods = {};
                Object.entries(resultFunds).map(([fundId, fundPeriods]) => {

                    Object.entries(fundPeriods).map(([period, fundInfos]) => {
                        if (period != "rentAcum" && period != "rentMoneyAcum") {
                            {

                                if (!formattedConsumesPeriods[period]) {
                                    formattedConsumesPeriods[period] = [];
                                }


                                if (fundInfos.rentMoney < 0) {
                                    formattedConsumesPeriods[period].push({
                                        ...fundInfos,
                                        fundId: fundId,
                                        fundName: mapFundNameByFundId[fundId],
                                        cnpj: mapFundCnpjByFundId[fundId],
                                    });
                                }

                            }
                        }

                    })


                })

                console.log("formattedConsumesPeriods: ", formattedConsumesPeriods);

                const formatedConsumesToTable = [];
                Object.entries(formattedConsumesPeriods).map(([period, arrayNegativesFunds]) => {


                    const splittedPeriod = period.split('/');

                    //Removendo dezembro
                    if (splittedPeriod[0] != "12") {
                        formatedConsumesToTable.push({
                            period: period,
                            periodName: getMonthName(splittedPeriod[0]) + '/' + splittedPeriod[1],
                            negativeBalance: arrayNegativesFunds.reduce((soma, item) => soma + (item.rentMoney || 0), 0),
                            arrayNegativesFunds: arrayNegativesFunds,
                        });
                    }
                })


                const sorted = sortObjsByPeriod(formatedConsumesToTable);
                setFormattedConsumes(sorted);

                console.log("Sorted: ", sorted);
                setInnerLoad(null);

            }

            console.log("responseYearLoss: ", responseYearLoss);

        }
        //loadFundsYear(clientOn.client);
    }

    const loadOptionsYearsToLossProvision = (client) => {

        const portfolioClosedDate = portfolioClosedToDate(client.portfolio_closed);
        const startDate = new Date(2024, 0, 1);

        const yearsWithNovembers = getYearsWithNovembers(startDate, portfolioClosedDate);

        setOptionsYearsLossProvision(yearsWithNovembers);

        if (yearsWithNovembers.length === 0) {
            setInnerLoad({
                emptyMessage: "A carteira deve possuir informação lançada pelo menos a partir de Nov/2024",
            })
        }

    }

    const [lossMonthsOpens, setLossMonthsOpens] = React.useState({});
    const handleLossMonthsOpens = (period) => {
        const newLossMonthsOpens = { ...lossMonthsOpens };
        if (!newLossMonthsOpens[period]) {
            newLossMonthsOpens[period] = false;
        }
        newLossMonthsOpens[period] = !newLossMonthsOpens[period];
        setLossMonthsOpens(newLossMonthsOpens);
    }

    const getColGroup = () => {
        return (
            <colgroup>
                <col width="35%" />
                <col width="25%" />
                <col width="15%" />
                <col width="10%" />
                <col width="15%" />
            </colgroup>
        )
    }

    const theFooters = useMemo(() => {

        const footers = [];
        const foorterResult = [];

        footers.push(

            <TableRow className={classes.totalLinePL} key={'footer-loss-provisional'}>
                <TableCell align="left">TOTAL PROVISÃO DE PERDAS</TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="right"><span className={'spanTotal'}>{totalLoss != null ?
                    applyMaskAmount(totalLoss, true) : '-'}</span></TableCell>
            </TableRow>

        );

        const totalConsumed = formattedConsumes.reduce((sum, item) => sum + (item.negativeBalance ? item.negativeBalance : 0), 0)

        console.log("formattedConsumes: ", formattedConsumes);

        formattedConsumes.forEach((row, index) => {
            const open = lossMonthsOpens[row.periodName];
            footers.push(
                <React.Fragment>
                    <TableRow
                        className={classes.theConsumeLine}
                        key={'z-client-fund-consumes' + index}
                    >
                        <TableCell align="left" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <IconButton aria-label="expand row" size="small"
                                className={[
                                    (!row.arrayNegativesFunds || (row.arrayNegativesFunds && row.arrayNegativesFunds.length) == 0) ?
                                        classes.hiddenIcon : "", classes.arrowTableIcon].join(' ')}
                                onClick={() => handleLossMonthsOpens(row.periodName)}>
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                            <div>{row.periodName}</div>
                        </TableCell>
                        <TableCell align="center"></TableCell>
                        <TableCell align="right"></TableCell>
                        <TableCell align="center"></TableCell>
                        <TableCell align="right" style={{ color: unoTheme.redMoney }}><span className={'spanTotal'}>{applyMaskAmount(row.negativeBalance, true)}</span></TableCell>

                    </TableRow>
                    <TableRow
                        className={[classes.innerTableRow, index % 2 == 0 ? classes.oddRow : "", open ? "" : classes.borderOnOpen].join(' ')}>
                        <TableCell style={{ padding: 0 }} colSpan={5}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Box>
                                    <Table size="small"
                                        className={classes.tableFixed}>
                                        {getColGroup()}
                                        <TableBody>
                                            {row.arrayNegativesFunds.map((lossFundInMonth, subIndex) => (
                                                <TableRow key={'loss-fund-in-month-' + index + "-" + subIndex}>
                                                    <TableCell align="left">{lossFundInMonth.fundName}</TableCell>
                                                    <TableCell align="center">{lossFundInMonth.cnpj}</TableCell>
                                                    <TableCell align="right"></TableCell>
                                                    <TableCell align="right"></TableCell>
                                                    <TableCell align="right" style={{ color: "orangered" }}>{lossFundInMonth.rentMoney != null ? applyMaskAmount(lossFundInMonth.rentMoney, true) : "-"}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                    </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </React.Fragment>



            )

            foorterResult.push({
                fund: row.periodName,
                cnpj: "PERIOD_LOSS_PROVISION",
                balance: "",
                var: "",
                provision: applyMaskAmount(row.negativeBalance, true),
            });

            row.arrayNegativesFunds.forEach(negativeFundInMonth => {
                foorterResult.push({
                    fund: negativeFundInMonth.fundName,
                    cnpj: negativeFundInMonth.cnpj,
                    balance: "",
                    var: "",
                    provision: applyMaskAmount(negativeFundInMonth.rentMoney, true),
                });
            });
        });

        const balanceLoss = totalLoss - (totalConsumed * (-1));

        footers.push(

            <TableRow className={classes.totalWithNegativesLinePL} key={'footer-loss-provisional-consumed'}>
                <TableCell align="left">TOTAL CONSUMIDO</TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="right"><span className={'spanTotal'}>{
                    applyMaskAmount(totalConsumed, true)}</span></TableCell>
            </TableRow>

        );

        footers.push(

            <TableRow className={classes.totalLinePL} key={'footer-loss-provisional-with-negatives'}>
                <TableCell align="left">SALDO DE PROVISÃO</TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="right"><span className={'spanTotal'}>{
                    applyMaskAmount(balanceLoss, true)}</span></TableCell>
            </TableRow>

        );

        foorterResult.push({
            fund: "TOTAL CONSUMIDO",
            cnpj: "",
            balance: "",
            var: "",
            provision: applyMaskAmount(totalConsumed, true),
        });

        foorterResult.push({
            fund: "SALDO DE PROVISÃO",
            cnpj: "",
            balance: "",
            var: "",
            provision: applyMaskAmount(balanceLoss, true),
        });

        setFooterLoss(foorterResult);

        return footers;
    }, [totalLoss, formattedConsumes, lossMonthsOpens])

    useEffect(() => {

        if (fundsFormatteds?.length) {
            setLossProvisionResult(fundsFormatteds);
        }
    }, [fundsFormatteds])

    useEffect(() => {
        if (clientOn?.client?.id && selectedYearLossProvision) {

            loadYearLossProvision(clientOn.client, selectedYearLossProvision);
        }
    }, [clientOn?.client?.id, selectedYearLossProvision])

    useEffect(() => {
        if (clientOn?.client?.id) {

            loadOptionsYearsToLossProvision(clientOn.client);
        }
    }, [clientOn?.client?.id])

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>

                {
                    enableGenerateLossProvisionYear && innerLoad == null ?

                        <div className={classes.flexCenterDiv}>

                            <UnoButton
                                onClick={() => loadFundsYear(clientOn.client, selectedYearLossProvision)}
                                style={{ marginRight: '16px' }}
                                size={'small'}
                                disabled={!enableGenerateLossProvisionYear}
                                type='primary'>
                                {"Gerar provisão de perdas " + (selectedYearLossProvision ? ("[" + selectedYearLossProvision + "]") : "")}
                            </UnoButton>

                        </div>

                        :

                        <MyTable stickyHeader
                            size="small">
                            {getColGroup()}

                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Fundo</TableCell>
                                    <TableCell align="center">CNPJ</TableCell>
                                    <TableCell align="right">Saldo {`(Nov/${selectedYearLossProvision})`}</TableCell>
                                    <TableCell align="center">VaR <span style={{ fontSize: "8px" }}>252,756</span></TableCell>
                                    <TableCell align="right">Provisão</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                clientOn?.client && fundsFormatteds?.length ?
                                    <TableBody>
                                        {fundsFormatteds.map((row, index) => (

                                            <TableRow key={'client-fund-loss-provision-' + index}>
                                                <TableCell align="left">{row.fund_name}</TableCell>
                                                <TableCell align="center">{row.cnpj}</TableCell>
                                                <TableCell align="right" className={classes.green}>{row.balance_now != null ? applyMaskAmount(row.balance_now, true) : "-"}</TableCell>
                                                <TableCell align="right" style={{ color: row.varMode == "36m" ? "blue" : "blueviolet" }}>
                                                    <LightTooltip
                                                        title={"VaR de " + row.varMode}
                                                        placement="top" arrow>
                                                        <span>{row.var != null ? applyMaskAmountFreeDecimals(row.var, null, 6) + "%" : "-"}</span>
                                                    </LightTooltip>
                                                </TableCell>
                                                <TableCell align="right" style={{ color: "orangered" }}>{row.provision != null ? applyMaskAmount(row.provision, true) : "-"}</TableCell>

                                            </TableRow>

                                        ))}

                                        {theFooters.length !== 0 && theFooters}
                                    </TableBody>
                                    : null
                            }



                        </MyTable>
                }

            </DefaultScrollWithHeaderContent>

        </div>
    );
}



